import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { acquireHeroVisit } from 'lib/heroMedia';

export function usePublishedHero(slot) {
  const location = useLocation();
  // Component lifetime plus navigation key: a remount is also a fresh entry.
  const visit = useMemo(() => ({ slot, entry: location.key, path: location.pathname }), [slot, location.key, location.pathname]);
  const [state, setState] = useState(null);
  useEffect(() => {
    if (!slot) return;
    let active = true;
    const lease = acquireHeroVisit(visit, slot);
    lease.promise.then(media => { if (active) setState({ visit, media }); },
      () => { if (active) setState({ visit, media: { slot, status: 'error' } }); });
    return () => { active = false; lease.release(); };
  }, [slot, visit]);
  // Synchronous identity check prevents a single previous-route frame.
  const media = state?.visit === visit ? state.media : { slot, status: 'resolving' };
  return { ...media, imageUrl: media.status === 'ready' ? media.displayUrl : '', imageAlt: media.imageAlt || '' };
}
